{
  "note": "Canonical genre taxonomy and Spotify raw-genre fold map. Source of truth for supabase/migrations/*_genre_canonical_fold.sql (regenerate by hand when editing). Runtime resolvers read genres_canonical + spotify_genre_map from the DB, not this file. Keys in `fold` are lowercase, space-collapsed raw values (Spotify artist genres, legacy display names, slug forms). `junk` values resolve to nothing and are dropped.",
  "canonical": [
    {
      "slug": "christmas",
      "name": "Christmas",
      "category": "Seasonal",
      "featured": true,
      "sort_order": 10
    },
    {
      "slug": "rock",
      "name": "Rock",
      "category": "Rock",
      "featured": true,
      "sort_order": 20
    },
    {
      "slug": "pop",
      "name": "Pop",
      "category": "Mainstream",
      "featured": true,
      "sort_order": 30
    },
    {
      "slug": "hip-hop",
      "name": "Hip Hop",
      "category": "Urban",
      "featured": true,
      "sort_order": 40
    },
    {
      "slug": "country",
      "name": "Country",
      "category": "Country",
      "featured": true,
      "sort_order": 50
    },
    {
      "slug": "metal",
      "name": "Metal",
      "category": "Rock",
      "featured": true,
      "sort_order": 60
    },
    {
      "slug": "dance-electronic",
      "name": "Dance/Electronic",
      "category": "EDM",
      "featured": true,
      "sort_order": 70
    },
    {
      "slug": "faith-and-religion",
      "name": "Faith & Religion",
      "category": "Faith",
      "featured": false,
      "sort_order": 80
    },
    {
      "slug": "classical",
      "name": "Classical",
      "category": "Classical",
      "featured": false,
      "sort_order": 90
    },
    {
      "slug": "soundtrack",
      "name": "Soundtrack",
      "category": "Film/TV",
      "featured": false,
      "sort_order": 100
    },
    {
      "slug": "disney",
      "name": "Disney",
      "category": "Film/TV",
      "featured": true,
      "sort_order": 110
    },
    {
      "slug": "childrens-music",
      "name": "Kids & Family",
      "category": "Kids",
      "featured": false,
      "sort_order": 120
    },
    {
      "slug": "musicals",
      "name": "Musicals",
      "category": "Film/TV",
      "featured": false,
      "sort_order": 130
    },
    {
      "slug": "jazz",
      "name": "Jazz",
      "category": "Jazz",
      "featured": false,
      "sort_order": 140
    },
    {
      "slug": "folk-acoustic",
      "name": "Folk & Acoustic",
      "category": "Folk",
      "featured": false,
      "sort_order": 150
    },
    {
      "slug": "rnb",
      "name": "R&B",
      "category": "Urban",
      "featured": false,
      "sort_order": 160
    },
    {
      "slug": "instrumental",
      "name": "Instrumental",
      "category": "Other",
      "featured": false,
      "sort_order": 170
    },
    {
      "slug": "party",
      "name": "Party",
      "category": "Other",
      "featured": false,
      "sort_order": 180
    },
    {
      "slug": "comedy",
      "name": "Comedy",
      "category": "Other",
      "featured": false,
      "sort_order": 190
    },
    {
      "slug": "halloween",
      "name": "Halloween",
      "category": "Seasonal",
      "featured": false,
      "sort_order": 200
    },
    {
      "slug": "world",
      "name": "World",
      "category": "Other",
      "featured": false,
      "sort_order": 210
    }
  ],
  "deactivate": [
    "electronic",
    "edm",
    "dance",
    "house",
    "trance",
    "dubstep",
    "alternative",
    "holiday"
  ],
  "fold": {
    "christmas": "christmas",
    "christmas music": "christmas",
    "christmas pop": "christmas",
    "christmas instrumental": "christmas",
    "christmas product": "christmas",
    "christmas standards": "christmas",
    "classic christmas": "christmas",
    "traditional christmas": "christmas",
    "new christmas": "christmas",
    "celtic christmas": "christmas",
    "country christmas": "christmas",
    "christmas jazz": "christmas",
    "pop christmas": "christmas",
    "cedm": "christmas",
    "holiday": "christmas",
    "holidays": "christmas",
    "xmas": "christmas",
    "villancicos": "christmas",
    "halloween": "halloween",
    "rock": "rock",
    "rock and roll": "rock",
    "rock-and-roll": "rock",
    "rockabilly": "rock",
    "neo-rockabilly": "rock",
    "classic rock": "rock",
    "soft rock": "rock",
    "hard rock": "rock",
    "album rock": "rock",
    "art rock": "rock",
    "arena rock": "rock",
    "acid rock": "rock",
    "acid jazz": "jazz",
    "psychedelic rock": "rock",
    "progressive rock": "rock",
    "progressive alternative": "rock",
    "southern rock": "rock",
    "roots rock": "rock",
    "surf rock": "rock",
    "yacht rock": "rock",
    "aor": "rock",
    "funk rock": "rock",
    "ska": "rock",
    "glam rock": "rock",
    "garage rock": "rock",
    "noise rock": "rock",
    "gothic rock": "rock",
    "blues rock": "rock",
    "folk rock": "rock",
    "country rock": "rock",
    "pop rock": "rock",
    "dance rock": "rock",
    "punk rock": "rock",
    "rap rock": "rock",
    "reggae rock": "world",
    "celtic rock": "rock",
    "acoustic rock": "rock",
    "action rock": "rock",
    "boston rock": "rock",
    "brazilian rock": "rock",
    "canadian rock": "rock",
    "finnish rock": "rock",
    "venezuelan rock": "rock",
    "j rock": "rock",
    "punk": "rock",
    "proto punk": "rock",
    "celtic punk": "rock",
    "ska punk": "rock",
    "skate punk": "rock",
    "horror punk": "rock",
    "folk punk": "rock",
    "hardcore": "rock",
    "hardcore punk": "rock",
    "post hardcore": "rock",
    "screamo": "rock",
    "emo": "rock",
    "midwest emo": "rock",
    "grunge": "rock",
    "post grunge": "rock",
    "new wave": "rock",
    "new wave pop": "rock",
    "indie": "rock",
    "japanese indie": "rock",
    "lo fi indie": "rock",
    "galician indie": "rock",
    "bergen indie": "rock",
    "dutch indie": "rock",
    "brighton indie": "rock",
    "vietnam indie": "rock",
    "alternative": "rock",
    "alternative rock": "rock",
    "modern alternative rock": "rock",
    "indie rock": "rock",
    "grunge pop": "rock",
    "jam band": "rock",
    "visual kei": "rock",
    "industrial": "rock",
    "industrial rock": "rock",
    "chuck berry twist": "rock",
    "metal": "metal",
    "heavy metal": "metal",
    "glam metal": "metal",
    "nu metal": "metal",
    "thrash metal": "metal",
    "alternative metal": "metal",
    "industrial metal": "metal",
    "melodic death metal": "metal",
    "death metal": "metal",
    "doom metal": "metal",
    "drone metal": "metal",
    "folk metal": "metal",
    "gothic metal": "metal",
    "groove metal": "metal",
    "medieval metal": "metal",
    "power metal": "metal",
    "progressive metal": "metal",
    "sludge metal": "metal",
    "trap metal": "metal",
    "rap metal": "metal",
    "celtic metal": "metal",
    "neo classical metal": "metal",
    "christian metal": "faith-and-religion",
    "metalcore": "metal",
    "deathcore": "metal",
    "mathcore": "metal",
    "djent": "metal",
    "neue deutsche harte": "metal",
    "pop": "pop",
    "dance pop": "pop",
    "electropop": "pop",
    "synthpop": "pop",
    "teen pop": "pop",
    "bubblegum pop": "pop",
    "power pop": "pop",
    "dream pop": "pop",
    "bedroom pop": "pop",
    "hyperpop": "pop",
    "k-pop": "pop",
    "korean pop": "pop",
    "j-pop": "pop",
    "japanese pop": "pop",
    "europop": "pop",
    "eurodance": "dance-electronic",
    "german pop": "pop",
    "swedish pop": "pop",
    "classic swedish pop": "pop",
    "classic italian pop": "pop",
    "belgian pop": "pop",
    "dutch pop": "pop",
    "dansk pop": "pop",
    "dansk": "pop",
    "dansktop": "pop",
    "nederpop": "pop",
    "polish pop": "pop",
    "canadian pop": "pop",
    "hindi pop": "pop",
    "desi pop": "pop",
    "sinhala pop": "pop",
    "telugu pop": "pop",
    "kannada pop": "pop",
    "malay pop": "pop",
    "malaysian pop": "pop",
    "v pop": "pop",
    "puerto rican pop": "pop",
    "viral pop": "pop",
    "antiviral pop": "pop",
    "bow pop": "pop",
    "channel pop": "pop",
    "indie pop": "pop",
    "modern indie pop": "pop",
    "indie poptimism": "pop",
    "acoustic pop": "pop",
    "new romantic": "pop",
    "boy band": "pop",
    "classic schlager": "pop",
    "schlager": "pop",
    "hollands": "pop",
    "alt z": "pop",
    "deep talent show": "pop",
    "soft pop": "pop",
    "adult standards": "jazz",
    "easy listening": "jazz",
    "hip hop": "hip-hop",
    "hip-hop": "hip-hop",
    "hip hop pop": "pop",
    "hip pop": "hip-hop",
    "hip hoh": "hip-hop",
    "rap": "hip-hop",
    "gangster rap": "hip-hop",
    "old school hip hop": "hip-hop",
    "east coast hip hop": "hip-hop",
    "west coast hip hop": "hip-hop",
    "southern hip hop": "hip-hop",
    "hardcore hip hop": "hip-hop",
    "experimental hip hop": "hip-hop",
    "alternative hip hop": "hip-hop",
    "german hip hop": "hip-hop",
    "portuguese hip hop": "hip-hop",
    "indonesian hip hop": "hip-hop",
    "vietnamese hip hop": "hip-hop",
    "canadian hip hop": "hip-hop",
    "boston hip hop": "hip-hop",
    "atl hip hop": "hip-hop",
    "bc underground hip hop": "hip-hop",
    "new jersey underground rap": "hip-hop",
    "golden age hip hop": "hip-hop",
    "country hip hop": "hip-hop",
    "country rap": "hip-hop",
    "christian hip hop": "faith-and-religion",
    "anime rap": "hip-hop",
    "k rap": "hip-hop",
    "malay rap": "hip-hop",
    "rap espanol": "hip-hop",
    "jazz rap": "hip-hop",
    "cloud rap": "hip-hop",
    "boom bap": "hip-hop",
    "g funk": "hip-hop",
    "crunk": "hip-hop",
    "crunk dirty": "hip-hop",
    "horrorcore": "hip-hop",
    "drill": "hip-hop",
    "uk drill": "hip-hop",
    "chicago drill": "hip-hop",
    "brooklyn drill": "hip-hop",
    "new york drill": "hip-hop",
    "aussie drill": "hip-hop",
    "nigerian drill": "hip-hop",
    "grime": "hip-hop",
    "uk grime": "hip-hop",
    "trap": "hip-hop",
    "kids hip hop": "childrens-music",
    "bounce": "hip-hop",
    "new orleans bounce": "hip-hop",
    "pop rap": "hip-hop",
    "pop-hip-hop": "hip-hop",
    "pop & hip-hop": "pop",
    "hip house": "dance-electronic",
    "r&b": "rnb",
    "rnb": "rnb",
    "contemporary r&b": "rnb",
    "uk r&b": "rnb",
    "uk rnb": "rnb",
    "dark r&b": "rnb",
    "latin r&b": "rnb",
    "pop r&b": "rnb",
    "soul": "rnb",
    "classic soul": "rnb",
    "british soul": "rnb",
    "neo soul": "rnb",
    "northern soul": "rnb",
    "southern soul": "rnb",
    "urban contemporary": "rnb",
    "motown": "rnb",
    "funk": "rnb",
    "jazz funk": "jazz",
    "quiet storm": "rnb",
    "country": "country",
    "classic country": "country",
    "classic country pop": "country",
    "traditional country": "country",
    "contemporary country": "country",
    "modern country rock": "country",
    "outlaw country": "country",
    "texas country": "country",
    "classic texas country": "country",
    "red dirt": "country",
    "alberta country": "country",
    "arkansas country": "country",
    "classic oklahoma country": "country",
    "british country": "country",
    "alt country": "country",
    "alternative country": "country",
    "country pop": "country",
    "pop country": "country",
    "country folk": "country",
    "acoustic country": "country",
    "honky tonk": "country",
    "bluegrass": "country",
    "americana": "country",
    "cajun": "country",
    "zydeco": "country",
    "rally house": "country",
    "sertanejo": "country",
    "sertanejo tradicional": "country",
    "sertanejo universitário": "country",
    "sierreno": "country",
    "country road": "country",
    "dance-electronic": "dance-electronic",
    "dance & electronic": "dance-electronic",
    "anime lo-fi": "dance-electronic",
    "electronic": "dance-electronic",
    "edm": "dance-electronic",
    "edm & dance": "dance-electronic",
    "dance": "dance-electronic",
    "house": "dance-electronic",
    "tech house": "dance-electronic",
    "deep house": "dance-electronic",
    "french house": "dance-electronic",
    "funky house": "dance-electronic",
    "chill house": "dance-electronic",
    "slap house": "dance-electronic",
    "big room": "dance-electronic",
    "melodic house": "dance-electronic",
    "small room": "dance-electronic",
    "trance": "dance-electronic",
    "progressive trance": "dance-electronic",
    "dream trance": "dance-electronic",
    "psytrance": "dance-electronic",
    "full on": "dance-electronic",
    "techno": "dance-electronic",
    "melodic techno": "dance-electronic",
    "dubstep": "dance-electronic",
    "brostep": "dance-electronic",
    "riddim": "dance-electronic",
    "drumstep": "dance-electronic",
    "drum and bass": "dance-electronic",
    "jungle": "dance-electronic",
    "breakbeat": "dance-electronic",
    "breakcore": "dance-electronic",
    "speedcore": "dance-electronic",
    "frenchcore": "dance-electronic",
    "happy hardcore": "dance-electronic",
    "hardstyle": "dance-electronic",
    "euphoric": "dance-electronic",
    "uk dance": "dance-electronic",
    "gaming edm": "dance-electronic",
    "moombahton": "dance-electronic",
    "brazilian bass": "dance-electronic",
    "melbourne bounce international": "dance-electronic",
    "electro": "dance-electronic",
    "electro swing": "dance-electronic",
    "covertronica": "dance-electronic",
    "synthwave": "dance-electronic",
    "vaporwave": "dance-electronic",
    "chillwave": "dance-electronic",
    "darkwave": "dance-electronic",
    "ebm": "dance-electronic",
    "glitch": "dance-electronic",
    "ambient": "dance-electronic",
    "ambient psychill": "dance-electronic",
    "downtempo fusion": "dance-electronic",
    "chill out": "dance-electronic",
    "mashup": "dance-electronic",
    "bossbeat": "dance-electronic",
    "disco": "dance-electronic",
    "disco polo": "dance-electronic",
    "lo-fi": "dance-electronic",
    "lo-fi beats": "dance-electronic",
    "lo-fi study": "dance-electronic",
    "lo-fi cover": "dance-electronic",
    "lo-fi vgm": "dance-electronic",
    "lo-fi hip hop": "dance-electronic",
    "ballroom vogue": "dance-electronic",
    "bulgarian experimental": "dance-electronic",
    "faith-and-religion": "faith-and-religion",
    "christian music": "faith-and-religion",
    "christian pop": "faith-and-religion",
    "christian rock": "faith-and-religion",
    "christian folk": "faith-and-religion",
    "christian country": "faith-and-religion",
    "christian alternative rock": "faith-and-religion",
    "christian": "faith-and-religion",
    "worship": "faith-and-religion",
    "pop worship": "faith-and-religion",
    "anthem worship": "faith-and-religion",
    "ambient worship": "faith-and-religion",
    "praise & worship": "faith-and-religion",
    "praise and worship": "faith-and-religion",
    "contemporary christian": "faith-and-religion",
    "gospel": "faith-and-religion",
    "contemporary gospel": "faith-and-religion",
    "gospel r&b": "faith-and-religion",
    "gospel rnb": "faith-and-religion",
    "ccm": "faith-and-religion",
    "religious": "faith-and-religion",
    "lds": "faith-and-religion",
    "hymn": "faith-and-religion",
    "classical": "classical",
    "classical piano": "classical",
    "classical performance": "classical",
    "21st century classical": "classical",
    "american modern classical": "classical",
    "american romanticism": "classical",
    "british contemporary classical": "classical",
    "british orchestra": "classical",
    "historically informed performance": "classical",
    "neoclassical": "classical",
    "neo-classical": "classical",
    "baroque": "classical",
    "romantic": "classical",
    "opera": "classical",
    "operatic pop": "classical",
    "orchestral": "classical",
    "orchestra": "classical",
    "chamber music": "classical",
    "symphony": "classical",
    "requiem": "classical",
    "choir": "classical",
    "choral": "classical",
    "cambridge choir": "classical",
    "soundtrack": "soundtrack",
    "movie": "soundtrack",
    "movie tunes": "soundtrack",
    "hollywood": "soundtrack",
    "drama": "soundtrack",
    "tv": "soundtrack",
    "tv & movie": "soundtrack",
    "tv-movie": "soundtrack",
    "british soundtrack": "soundtrack",
    "classic soundtrack": "soundtrack",
    "canadian soundtrack": "soundtrack",
    "german soundtrack": "soundtrack",
    "rchestral soundtrack": "soundtrack",
    "orchestral soundtrack": "soundtrack",
    "anime": "soundtrack",
    "anime cv": "soundtrack",
    "otacore": "soundtrack",
    "vocaloid": "soundtrack",
    "video game music": "soundtrack",
    "video game soundtrack": "soundtrack",
    "japanese vgm": "soundtrack",
    "rhythm game": "soundtrack",
    "epicore": "soundtrack",
    "bollywood": "soundtrack",
    "tollywood": "soundtrack",
    "disney": "disney",
    "childrens-music": "childrens-music",
    "children's music": "childrens-music",
    "childrens music": "childrens-music",
    "kids & family": "childrens-music",
    "family": "childrens-music",
    "kids": "childrens-music",
    "canadian children's music": "childrens-music",
    "lullaby": "childrens-music",
    "cartoon": "childrens-music",
    "musicals": "musicals",
    "musical": "musicals",
    "broadway": "musicals",
    "show tunes": "musicals",
    "german show tunes": "musicals",
    "cabaret": "musicals",
    "dark cabaret": "musicals",
    "a cappella": "musicals",
    "a-cappella": "musicals",
    "vocal harmony group": "musicals",
    "jazz": "jazz",
    "smooth jazz": "jazz",
    "contemporary jazz": "jazz",
    "vocal jazz": "jazz",
    "cool jazz": "jazz",
    "hard bop": "jazz",
    "bebop": "jazz",
    "dinner jazz": "jazz",
    "soul jazz": "jazz",
    "ethiopian jazz": "jazz",
    "jazz blues": "jazz",
    "jazz fusion": "jazz",
    "jazz trio": "jazz",
    "big band": "jazz",
    "swing": "jazz",
    "swing music": "jazz",
    "doo wop": "jazz",
    "doo-wop": "jazz",
    "boogie woogie": "jazz",
    "blues": "jazz",
    "modern blues": "jazz",
    "soul blues": "jazz",
    "folk-acoustic": "folk-acoustic",
    "folk": "folk-acoustic",
    "folk pop": "folk-acoustic",
    "indie folk": "folk-acoustic",
    "traditional folk": "folk-acoustic",
    "anti folk": "folk-acoustic",
    "singer songwriter": "folk-acoustic",
    "singer-songwriter": "folk-acoustic",
    "italian singer songwriter": "folk-acoustic",
    "celtic": "folk-acoustic",
    "canadian celtic": "folk-acoustic",
    "sea shanties": "folk-acoustic",
    "medieval": "folk-acoustic",
    "irish dance": "folk-acoustic",
    "acoustic": "folk-acoustic",
    "acoustic guitar cover": "folk-acoustic",
    "new age": "instrumental",
    "instrumental": "instrumental",
    "piano cover": "instrumental",
    "karaoke": "instrumental",
    "marching band": "instrumental",
    "college marching band": "instrumental",
    "military band": "instrumental",
    "party": "party",
    "birthday": "party",
    "schlagerparty": "party",
    "comedy": "comedy",
    "comic": "comedy",
    "meme": "comedy",
    "novelty": "comedy",
    "world": "world",
    "reggae": "world",
    "reggae fusion": "world",
    "dancehall": "world",
    "ragga": "world",
    "soca": "world",
    "afrobeat": "world",
    "afrobeats": "world",
    "afropop": "world",
    "azonto": "world",
    "hiplife": "world",
    "malay": "world",
    "bolero": "world",
    "vietnamese bolero": "world",
    "latin": "world",
    "urbano latino": "world",
    "trap latino": "world",
    "reggaeton": "world",
    "reggaeton chileno": "world",
    "cornetas y tambores": "world",
    "techengue": "world",
    "dance/electronic": "dance-electronic",
    "folk & acoustic": "folk-acoustic"
  },
  "junk": [
    "tyler",
    "the creator",
    "squidward",
    "discovery",
    "them",
    "ids",
    "ids youth",
    "musique, vol. 1",
    "musique vol. 1"
  ]
}
